/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-11-17 11:20:22
 * @Description: 菜单配置
 */
import { NameEnum, UnionEnum, UrlEnum } from '@/utils/enums/Route'

export const menuConfig = {
  default: [
    {
      id: 1,
      svgIcon: 'menu-home',
      menuName: NameEnum[UnionEnum.Home],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.Home],
      children: []
    },
    // {
    //   id: 2,
    //   svgIcon: 'menu-abnormal',
    //   menuName: NameEnum[UnionEnum.ABNORMALPAYMENT],
    //   parentId: 0,
    //   menuUrl: UrlEnum[UnionEnum.ABNORMALPAYMENT],
    //   children: []
    // },
    {
      id: '1001',
      svgIcon: 'menu-packManage',
      menuName: '包裹管理',
      parentId: 0,
      children: [
        {
          id: '1966764251001372674',
          parentId: '1001',
          menuName: '客户问询列表',
          menuUrl: '/inquiryList'
        },
        {
          id: '1834133851880783873',
          parentId: '1001',
          menuName: '派件包裹列表',
          menuUrl: '/dispatchList'
        }
      ]
    }
    // TODO 隐藏寄件
    // {
    //   id: 3,
    //   svgIcon: 'menu-order',
    //   menuName: NameEnum[UnionEnum.ORDERWRITER],
    //   parentId: 0,
    //   menuUrl: UrlEnum[UnionEnum.ORDERWRITER],
    //   children: []
    // },
    // {
    //   id: 5,
    //   svgIcon: 'menu-orderList',
    //   menuName: NameEnum[UnionEnum.ORDERLIST],
    //   parentId: 0,
    //   menuUrl: UrlEnum[UnionEnum.ORDERLIST],
    //   children: []
    // },
    // {
    //   id: 4,
    //   svgIcon: 'menu-users',
    //   menuName: NameEnum[UnionEnum.ADDRESS],
    //   parentId: 20,
    //   menuUrl: UrlEnum[UnionEnum.ADDRESS],
    //   children: []
    // }
    // END TODO
    // {
    //   id: 20,
    //   icon: operateImg,
    //   menuName: NameEnum[UnionEnum.ORDERMANAGER],
    //   parentId: 0,
    //   children: [
    // 散单对账单
    // {
    //   id: 25,
    //   icon: '',
    //   menuName: NameEnum[UnionEnum.STATEMENT],
    //   parentId: 20,
    //   menuUrl: UrlEnum[UnionEnum.STATEMENT],
    //   children: []
    // },
    // ]
    // }
  ],
  vn: [
    {
      id: 1,
      svgIcon: 'menu-home',
      menuName: NameEnum[UnionEnum.Home],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.Home],
      children: []
    },
    {
      id: 2,
      svgIcon: 'menu-abnormal',
      menuName: NameEnum[UnionEnum.ABNORMALPAYMENT],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.ABNORMALPAYMENT],
      children: []
    },
    {
      id: 3,
      svgIcon: 'menu-order',
      menuName: NameEnum[UnionEnum.ORDERWRITER],
      parentId: 0,
      menuUrl: '/orderEntry',
      children: []
    },
    {
      id: '1001',
      svgIcon: 'menu-packManage',
      menuName: '包裹管理',
      parentId: 0,
      children: [
        {
          id: '1002',
          parentId: '1001',
          menuName: NameEnum[UnionEnum.ORDERLIST],
          menuUrl: UrlEnum[UnionEnum.ORDERLIST]
        },
        {
          id: '1003',
          parentId: '1001',
          menuName: '入库包裹查询',
          menuUrl: '/dispatchList'
        }
      ]
    },
    {
      id: 4,
      svgIcon: 'menu-users',
      menuName: NameEnum[UnionEnum.ADDRESS],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.ADDRESS],
      children: []
    }
  ],
  id: [
    {
      id: 1,
      svgIcon: 'menu-home',
      menuName: NameEnum[UnionEnum.Home],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.Home],
      children: []
    },
    // {
    //   id: 2,
    //   svgIcon: 'menu-abnormal',
    //   menuName: NameEnum[UnionEnum.ABNORMALPAYMENT],
    //   parentId: 0,
    //   menuUrl: UrlEnum[UnionEnum.ABNORMALPAYMENT],
    //   children: []
    // },
    {
      id: 3,
      svgIcon: 'menu-order',
      menuName: NameEnum[UnionEnum.ORDERWRITER],
      parentId: 0,
      menuUrl: '/orderEntry',
      children: []
    },
    {
      id: '1001',
      svgIcon: 'menu-packManage',
      menuName: '包裹管理',
      parentId: 0,
      children: [
        {
          id: '1002',
          parentId: '1001',
          menuName: NameEnum[UnionEnum.ORDERLIST],
          menuUrl: UrlEnum[UnionEnum.ORDERLIST]
        },
        {
          id: '1003',
          parentId: '1001',
          menuName: '派件包裹列表',
          menuUrl: '/dispatchList'
        },
        {
          id: '1004',
          parentId: '1001',
          menuName: '退件包裹列表',
          menuUrl: '/returnList'
        }
      ]
    },
    {
      id: 4,
      svgIcon: 'menu-users',
      menuName: NameEnum[UnionEnum.ADDRESS],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.ADDRESS],
      children: []
    }
  ],
  my: [
    {
      id: 1,
      svgIcon: 'menu-home',
      menuName: NameEnum[UnionEnum.Home],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.Home],
      stationType: ['MAIL', 'DELIVERY', 'MAIL_DELIVERY'],
      children: []
    },
    {
      id: 3,
      svgIcon: 'menu-order',
      menuName: NameEnum[UnionEnum.ORDERWRITER],
      parentId: 0,
      menuUrl: '/orderEntry',
      stationType: ['MAIL', 'MAIL_DELIVERY'],
      children: []
    },
    {
      id: '1001',
      svgIcon: 'menu-packManage',
      menuName: '包裹管理',
      parentId: 0,
      stationType: ['MAIL', 'DELIVERY', 'MAIL_DELIVERY'],
      children: [
        {
          id: '1966764251001372674',
          parentId: '1001',
          menuName: '客户问询列表',
          menuUrl: '/inquiryList',
          stationType: ['DELIVERY', 'MAIL_DELIVERY']
        },
        {
          id: '10012',
          parentId: '1001',
          menuName: NameEnum[UnionEnum.ORDERLIST],
          menuUrl: UrlEnum[UnionEnum.ORDERLIST],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        },
        {
          id: '1834133851880783873',
          parentId: '1001',
          menuName: '派件包裹列表',
          menuUrl: '/dispatchList',
          stationType: ['DELIVERY', 'MAIL_DELIVERY']
        }
      ]
    },
    {
      id: '4',
      svgIcon: 'menu-users',
      menuName: NameEnum[UnionEnum.ADDRESS],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.ADDRESS],
      stationType: ['MAIL', 'MAIL_DELIVERY'],
      children: []
    },
    {
      id: '1002',
      svgIcon: 'menu-smsManagement',
      menuName: '信息发送管理',
      parentId: 0,
      menuUrl: '/yoyiInformation',
      stationType: ['MAIL', 'DELIVERY', 'MAIL_DELIVERY']
    },
    {
      id: '1003',
      svgIcon: 'menu-order',
      menuName: '财务结算',
      parentId: 0,
      stationType: ['DELIVERY', 'MAIL_DELIVERY'],
      children: [
        {
          id: '1966764251001372676',
          parentId: '1001',
          menuName: '派件费账单管理',
          menuUrl: '/dispatchBillManagement',
          stationType: ['DELIVERY', 'MAIL_DELIVERY']
        }
      ]
    },
    {
      id: '1004',
      svgIcon: 'menu-setting',
      menuName: '普通预付款',
      parentId: 0,
      stationType: ['MAIL', 'MAIL_DELIVERY'],
      children: [
        {
          id: '1004-1',
          parentId: '1004',
          menuName: NameEnum[UnionEnum.ADVANCE_MANAGEMENT],
          menuUrl: UrlEnum[UnionEnum.ADVANCE_MANAGEMENT],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        },
        {
          id: '1004-3',
          parentId: '1004',
          menuName: NameEnum[UnionEnum.ADVANCE_INQUIRY],
          menuUrl: UrlEnum[UnionEnum.ADVANCE_INQUIRY],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        },
        {
          id: '1004-5',
          parentId: '1004',
          menuName: NameEnum[UnionEnum.AUDIT_MANAGEMENT],
          menuUrl: UrlEnum[UnionEnum.AUDIT_MANAGEMENT],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        },
        {
          id: '1004-7',
          parentId: '1004',
          menuName: NameEnum[UnionEnum.FAILURE_MANAGEMENT],
          menuUrl: UrlEnum[UnionEnum.FAILURE_MANAGEMENT],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        }
      ]
    },
    {
      id: '1005',
      svgIcon: 'menu-setting',
      menuName: 'COD预付款',
      parentId: 0,
      stationType: ['MAIL', 'MAIL_DELIVERY'],
      children: [
        {
          id: '1005-1',
          parentId: '1005',
          menuName: NameEnum[UnionEnum.COD_ADVANCE_MANAGEMENT],
          menuUrl: UrlEnum[UnionEnum.COD_ADVANCE_MANAGEMENT],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        },
        {
          id: '1005-3',
          parentId: '1005',
          menuName: NameEnum[UnionEnum.COD_ADVANCE_INQUIRY],
          menuUrl: UrlEnum[UnionEnum.COD_ADVANCE_INQUIRY],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        },
        {
          id: '1005-5',
          parentId: '1005',
          menuName: NameEnum[UnionEnum.COD_AUDIT_MANAGEMENT],
          menuUrl: UrlEnum[UnionEnum.COD_AUDIT_MANAGEMENT],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        },
        {
          id: '1005-7',
          parentId: '1005',
          menuName: NameEnum[UnionEnum.COD_FAILURE_MANAGEMENT],
          menuUrl: UrlEnum[UnionEnum.COD_FAILURE_MANAGEMENT],
          stationType: ['MAIL', 'MAIL_DELIVERY']
        }
      ]
    }
  ],
  ph: [
    {
      id: 1,
      svgIcon: 'menu-home',
      menuName: NameEnum[UnionEnum.Home],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.Home],
      children: []
    },
    {
      id: '102',
      svgIcon: 'menu-expressTracking',
      menuName: '快件跟踪',
      parentId: 0,
      menuUrl: '/expressTracking',
      children: []
    },
    {
      id: 3,
      svgIcon: 'menu-order',
      menuName: NameEnum[UnionEnum.ORDERWRITER],
      parentId: 0,
      menuUrl: '/orderEntry',
      children: []
    },
    {
      id: '1001',
      svgIcon: 'menu-packManage',
      menuName: '包裹管理',
      parentId: 0,
      children: [
        {
          id: '1002',
          parentId: '1001',
          menuName: NameEnum[UnionEnum.ORDERLIST],
          menuUrl: UrlEnum[UnionEnum.ORDERLIST]
        },
        {
          id: '1003',
          parentId: '1001',
          menuName: '派件包裹列表',
          menuUrl: '/dispatchList'
        },
        {
          id: '1004',
          parentId: '1001',
          menuName: '国际件',
          menuUrl: '/internationalList'
        }
      ]
    },
    {
      id: 4,
      svgIcon: 'menu-users',
      menuName: NameEnum[UnionEnum.ADDRESS],
      parentId: 0,
      menuUrl: UrlEnum[UnionEnum.ADDRESS],
      children: []
    },
    {
      id: '1006',
      svgIcon: 'menu-packManage',
      menuName: '资金管理',
      parentId: 0,
      children: [
        {
          id: '10061',
          parentId: '1006',
          menuName: '寄件提成报表',
          menuUrl: '/sendCommissionReport'
        },
        {
          id: '10062',
          parentId: '1006',
          menuName: '冲单激励',
          menuUrl: '/PerformanceReward'
        }
      ]
    }
  ]
}
